/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import { CallHistoryModal } from 'components/lab/CallHistoryModal'
import { formatPhoneNumber } from 'helpers/format'

interface Props {
  phoneNumber: string | null | undefined
  /** ISO date string — order completed/cancelled date; defaults to today when omitted */
  dateTo?: string
  /** Render as plain text when Intermedia is not needed */
  disabled?: boolean
}

export const ClickablePhone = ({ phoneNumber, dateTo, disabled }: Props) => {
  const [open, setOpen] = useState(false)

  if (!phoneNumber) return null

  if (disabled) {
    return <span>{formatPhoneNumber(phoneNumber)}</span>
  }

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        css={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#2C83BD',
          cursor: 'pointer',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          fontFamily: 'inherit',
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          '&:hover': { color: '#1a5f8a' },
        }}>
        {formatPhoneNumber(phoneNumber)}
      </button>

      {open && (
        <CallHistoryModal phoneNumber={phoneNumber} dateTo={dateTo} onClose={() => setOpen(false)} />
      )}
    </>
  )
}
